// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-listbox-option-border-color: var(--ds-color-grey-indigo-40);
    --ds-listbox-option-selected-border-color: var(--ds-color-neon-0);
    --ds-listbox-option-focused-border-color: var(--ds-color-grey-40);
    --ds-listbox-option-bg-color: var(--ds-color-grey-indigo-80);
    --ds-listbox-option-hover-bg-color: var(--ds-color-grey-indigo-70);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
